import * as Yup from "yup";
import { admin, hr } from "../Constant";

export const canAddBackdatedExpenses = (role?: string) =>
  [admin, hr].includes(role?.trim().toLowerCase() ?? "");

export const getExpenseMonthStart = (today: Date) =>
  new Date(today.getFullYear(), today.getMonth() - (today.getDate() <= 7 ? 1 : 0), 1);

export const expenseDateValidation = (
  requiredMessage: string,
  invalidMessage: string,
) =>
  Yup.date()
    .required(requiredMessage)
    .typeError(invalidMessage)
    .test("expense-date-range", function (value) {
      if (!value) return true;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selectedDay = new Date(value.getFullYear(), value.getMonth(), value.getDate());
      if (selectedDay > today) {
        return this.createError({ message: "Future expense dates are not allowed" });
      }
      const monthStart = getExpenseMonthStart(today);
      if (
        selectedDay < monthStart &&
        !canAddBackdatedExpenses(this.options.context?.loggedInEmployeeRole)
      ) {
        return this.createError({ message: `Select a date from ${monthStart.toLocaleDateString()} through today` });
      }
      return true;
    });
